<template>
  <div>
    <v-overlay :value="peticionCliente">
    <Loading  />
    </v-overlay>
    <v-card
      v-if="$vuetify.breakpoint.mdAndUp"
      :class="['rounded-md', 'v-cardgrid']"
    >
      <div
        style="color: #4d6572"
        class="subtitle-1 font-weight-bold text-center"
      >
        Consulta Articulos Clientes
      </div>
      <v-divider></v-divider>
      <v-card-title v-if="!peticionCliente">
        <v-toolbar dense class="elevation-0">
          <v-row no-gutters>
            <v-col cols="12" md="3">
              <v-switch
                inset
                class="mt-4"
                v-model="selectedItem"
                :label="`${verMontoCantidad ? 'Ver Montos' : 'Ver Cantidades'}`"
                color="#fe5000"
              ></v-switch>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="search"
                color="accent"
                hide-details
                dense
                filled
                single-line
                clear-icon="mdi-close-circle"
                clearable
                label="Buscar Articulo"
                type="text"
                append-icon="mdi-magnify"
                class="mt-3"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </v-card-title>

      <v-data-table
        :headers="headersCat"
        hide-default-header
        hide-default-footer
        disable-pagination
        class="elevation-1"
        :items="itemsTable"
        dense
        id="row-pointer"
        item-key="Nombre"
        :expanded.sync="expanded"
        @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
        single-expand
      >
        <template v-slot:[`group.header`]="{ items, group, toggle }">
          <td :colspan="mesAnnio + 4">
            <v-btn @click="toggle" x-small icon :ref="group">
              <v-icon v-if="group.isOpen">mdi-minus</v-icon>
              <v-icon v-else>mdi-plus</v-icon>
            </v-btn>
            <span style="color: #4d6572" class="mx-6 font-weight-bold">{{
              items[0].Nombre
            }}</span>
          </td>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-card class="borderTop" outlined color="accent">
              <v-data-table
                :headers="headersArt"
                hide-default-header
                hide-default-footer
                disable-pagination
                dense
                id="tbl_datos"
                :items="item.Articulos"
                :search="search"
                :custom-filter="filterArt"
              >
                <template v-slot:header="{ props }">
                  <th :class="props.headers[0].class">Codigo</th>
                  <th :class="props.headers[1].class">Articulo</th>
                  <th
                    :class="props.headers[2].class"
                    v-for="n in mesAnnio + 1"
                    :key="n"
                  >
                    <span class="mx-3">{{ MesNb(n) }}</span>
                  </th>
                  <th :class="props.headers[2].class">
                    <span class="mr-3">Total</span>
                  </th>
                </template>
                <template v-slot:item="{ item }">
                  <tr style="cursor: text">
                    <td
                      :class="[
                        {
                          'caption text-left font-weight-bold':
                            $vuetify.breakpoint.lgAndDown,
                        },
                        {
                          'subtitle-2 text-left font-weight-bold':
                            $vuetify.breakpoint.xlOnly,
                        },
                      ]"
                    >
                      {{ item.Articulo }}
                    </td>
                    <td
                      :class="[
                        {
                          'caption text-left font-weight-bold':
                            $vuetify.breakpoint.lgAndDown,
                        },
                        {
                          'subtitle-2 text-left font-weight-bold':
                            $vuetify.breakpoint.xlOnly,
                        },
                      ]"
                    >
                      {{ item.NombreArt }}
                    </td>
                    <td
                      :class="[
                        {
                          'text-no-wrap body-2 text-right font-weight-bold':
                            $vuetify.breakpoint.lgAndDown,
                        },
                        {
                          'text-no-wrap subtitle-2 text-right font-weight-bold':
                            $vuetify.breakpoint.xlOnly,
                        },
                      ]"
                      v-for="n in mesAnnio + 1"
                      :key="n"
                    >
                      <span v-if="!verMontoCantidad">
                        {{
                          item.MontoMesExt[n - 1] != 0
                            ? simboloMoneda[tipoMoneda]
                            : ""
                        }}
                        {{ formatItem(item.MontoMesExt[n - 1]) | nocero }}
                      </span>
                      <span v-if="verMontoCantidad">
                        {{ formatItem(item.UnidadesMes[n - 1]) | nocero }}
                      </span>
                    </td>
                    <td
                      :class="[
                        {
                          'text-no-wrap body-2 text-right font-weight-bold text-no-wrap':
                            $vuetify.breakpoint.lgAndDown,
                        },
                        {
                          'subtitle-2 text-right font-weight-bold':
                            $vuetify.breakpoint.xlOnly,
                        },
                      ]"
                    >
                      <span v-if="!verMontoCantidad">
                        {{
                          item.TotalAno[tipoMoneda] != 0
                            ? simboloMoneda[tipoMoneda]
                            : ""
                        }}
                        {{ item.TotalAno[tipoMoneda] | numeral("0,00") }}
                      </span>

                      <span v-if="verMontoCantidad">
                        {{ item.Unidades | numeral("0,00") | nocero }}
                      </span>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {Loading} from "@/components/LoadingDomo"
import { redondeo } from "@/static/funciones";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  filters: {
    nocero: function (value) {
      return parseInt(value) != 0 ? value : "";
    },
  },
  components:{
    Loading
  },
  props: {
    tipocliente: Boolean,
  },
  beforeDestroy() {
    console.log("beforeDestroy");
    this.cancelAllRequests();
  },
  data() {
    return {
      page: 1,
      dataArticulos: [],
      itemsPerPage: 2,
      search: "",
      selected: 0,
      propAbrir: false,
      groups: [1002, 1018],
      expanded: [],
      headersCat: [
        {
          text: "Nombre",
          align: "left",
          value: "Nombre",
          width: "170px",
          sortable: true,
          divider: true,
          class: "black--text subtitle-2 font-weight-regular d-print-none",
        },
        {
          text: "Suma",
          align: "right",
          value: "Suma",
          width: "170px",
          sortable: true,
          divider: true,
          class: "black--text subtitle-2 font-weight-regular d-print-none",
        },
      ],
      headersArt: [
        {
          text: "Articulo",
          align: "left",
          value: "Articulo",
          width: "170px",
          sortable: true,
          divider: true,
          class: "black--text subtitle-2 font-weight-regular d-print-none",
        },
        {
          text: "Nombre",
          align: "left",
          value: "NombreArt",
          width: "300px",
          sortable: true,
          divider: true,
          class: "black--text subtitle-2 font-weight-regular d-print-none",
        },

        {
          sortable: true,
          text: "Mes",
          class:
            "black--text subtitle-2 font-weight-regular d-print-none  text-right",
        },
      ],
    };
  },
  /*   mounted() {
  this.initializeGroupState(this.itemsTable);
}, */
  methods: {
    ...mapMutations("mod_cliente", [
      "CLEAR_CONTROLLERS",
      "set_verMontoCantidad",
      "clr_wfVentasAno",
      "SET_SHOULD_CONTINUE"
    ]),
    ...mapActions("mod_cliente", ["cargarDatosCliente", "resetShouldContinue"]),
    redondeo,
    /*    

<span v-if="!verMontoCantidad">
                    {{
                      item.TotalAno[tipoMoneda] != 0
                        ? simboloMoneda[tipoMoneda]
                        : ""
                    }}
                    {{ item.TotalAno[tipoMoneda] | numeral("0,00") }}
                  </span>

                  <span v-if="verMontoCantidad">
                    {{ item.Unidades | numeral("0,00") | nocero }}
                  </span>
  
  
  */
    //moneda:this.tipoMoneda, vermonto:this.verMontoCantidad
    groupBy({ objectArray, property, moneda, vermonto }) {
      const grouped = objectArray.reduce(function (total, obj) {
        const key = obj[property];
        if (!total[key]) {
          total[key] = {
            items: [],
            nombre: obj.NombreCat,
            sumMonto: 0,
          };
        }

        total[key].sumMonto += !vermonto
          ? redondeo(obj.TotalAno[moneda], 1)
          : obj.Unidades;
        /* total[key].cantidad += obj.Cantidad; */
        total[key].items.push(obj);

        return total;
      }, {});
      const itemsAcc = Object.entries(grouped).map(([Codigo, Item]) => ({
        Codigo,
        Nombre: Item.nombre,
        Articulos: Item.items,

        Suma: this.formatItem(Item.sumMonto),

        //Cantidad: Item.cantidad,
      }));

      return itemsAcc;
    },
    cancelAllRequests() {
      this.CLEAR_CONTROLLERS();
    },
    async obtenerDatosCliente(opc, vende, clie, GrupoCli) {
      this.clr_wfVentasAno();
      const numCat = this.categorias.map((itemCat) => itemCat.Categoria);
     this.resetShouldContinue()
      for (const idCat of numCat) {
        if (!this.shouldContinue) {
          console.log("Ciclo detenido por cambio de tab");
          break;
        }
        try {
          await this.cargarDatosCliente({
            idCia: 1,
            userw: this.dataUser.Usuario,
            suc: 0,
            div: 0,
            dep: 0,
            cat: idCat,
            vend: vende,
            clie,
            GrupoCli: GrupoCli ? 1 : 0,
            dia: 0,
            sem: 0,
            mes: 0,
            annio: new Date().getFullYear(),
            opc: opc,
          });
        } catch (error) {
          if (error.name === "AbortError") {
            console.log("Petición abortada");
            break;
          } else {
            console.error("Error en la petición", error);
          }
        }
      }
    },
    closeAll() {
      Object.keys(this.$refs).forEach((k) => {
        if (this.$refs[k] && this.$refs[k].$attrs["data-open"]) {
          this.$refs[k].$el.click();
        }
      });
    },
    onScroll(e) {
      !this.propAbrir && this.closeAll();
    },
    abrir(iso) {
      iso ? (this.propAbrir = true) : (this.propAbrir = false);
    },
    filterArt(value, search, item) {
      let txt = `${item.Articulo} ${item.NombreArt}`;
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        txt.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
  created() {
    this.CLEAR_CONTROLLERS();
    this.obtenerDatosCliente(
      3,
      this.infoCliente(`CodigoVen`, 0),
      this.infoCliente(`Codigo`, 1),
      this.tipocliente
    );
    this.closeAll();
  },
  computed: {
    ...mapState("mod_cliente", [
      "wfVentasAno",
      "verMontoCantidad",
      "peticionCliente",
      "controllers",
      "shouldContinue",
    ]),
    ...mapState([
      "simboloMoneda",
      "tipoMoneda",
      "dataUser",
      "Cliente",
      "maestro",
    ]),
    /*
        datosNew() {
      let arr = [];
      if (Object.entries(this.wfVentasAno).length !== 0) {
        arr = this.wfVentasAno.datos.wfVentasAno;
      }
      return arr;
    },

    */
    itemsTable() {
      let arr = [];
      if (Object.entries(this.wfVentasAno).length !== 0) {
        arr = this.groupBy({
          objectArray: this.wfVentasAno.flat(),
          property: "CategoriaDiv",
          moneda: this.tipoMoneda,
          vermonto: this.verMontoCantidad,
        });
      }
      return arr;
    },
    categorias() {
      if (Object.entries(this.maestro).length !== 0) {
        return this.maestro.ttCategoria;
      }
    },
    selectedItem: {
      get() {
        return this.verMontoCantidad;
      },
      set() {
        this.set_verMontoCantidad();
      },
    },

    gruposSelected: function () {
      return function (data) {
        return dato.map((item) => item.GrupoCat);
      };
    },

    infoCliente: function () {
      return function (idKey, idNodo) {
        let xInfo = [];
        let infoData = {
            0: `resumen`,
            1: `data`,
          },
          attrib = infoData[idNodo];

        if (Object.entries(this.Cliente[attrib]).length !== 0) {
          let { [idKey]: Codigo } = this.Cliente[attrib];
          let { [idKey]: Nombre } = this.Cliente[attrib];
          let { [idKey]: Descuento } = this.Cliente[attrib];
          let { [idKey]: CodigoVen } = this.Cliente[attrib];
          let { [idKey]: NombreVen } = this.Cliente[attrib];
          let { [idKey]: GrupoCliente } = this.Cliente[attrib];

          if (Codigo !== undefined) xInfo = Codigo;
          if (Nombre !== undefined) xInfo = Nombre;
          if (Descuento !== undefined) xInfo = Descuento;
          if (CodigoVen !== undefined) xInfo = CodigoVen;
          if (NombreVen !== undefined) xInfo = NombreVen;
          if (GrupoCliente !== undefined) xInfo = GrupoCliente;
        }
        return xInfo;
      };
    },
    formatItem: function () {
      let numeral = require("numeral");
      //  return (val) => val <= 0.5 && val >= -0.49 ? numeral(val).format('0,0.00') : numeral(val).format("0,00");
      return (val) => numeral(val).format("0,00");
    },
    MesNb: function () {
      return function (fecha) {
        let mes = fecha;
        let cad = null;
        let meses = [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sept",
          "Oct",
          "Nov",
          "Dic",
        ];
        cad = meses[parseInt(mes) - 1];

        return cad;
      };
    },
    mesAnnio() {
      var d = new Date();
      var n = d.getMonth();

      /* if (
        this.fechaA !=
        new Date().toLocaleString("sv", { timeZoneName: "short" }).substr(0, 4)
      )
        return 11;
      else */ return n;
    },
    itemPage() {
      return this.selected;
    },
    numPage() {
      return Math.ceil(
        this.wfVentasAno.datos.wfVentasAno.length / this.itemPage
      );
    },
    visiblePages() {
      let xDatos;
      if (Object.entries(this.wfVentasAno).length != 0) {
        xDatos = this.wfVentasAno.datos.wfVentasAno.slice(
          (this.page - 1) * this.itemPage,
          this.page * this.itemPage
        );
      }
      return xDatos;
    },

    TotalArt() {
      let numeral = require("numeral");
      console.log(this.simboloMoneda[this.tipoMoneda]);
      let total = `${this.simboloMoneda[this.tipoMoneda]} ${numeral(
        this.wfVentasAno.datos.wfTotalAno[0].TotalAno[this.tipoMoneda]
      ).format("0,00.00")}`;
      let unidades = ` ${numeral(
        this.wfVentasAno.datos.wfTotalAno[0].Unidades
      ).format("0,00")}`;
      return this.verMontoCantidad ? unidades : total;
    },
  },
};
</script>

<style scoped>
.tbl_datos tr:nth-child(odd) {
  background: #ffffff;

  font-size: 10px;
}
.tbl_datos tr:nth-child(even) {
  font-size: 10px;
  background: #e0e0e0;
}

.v-cardgrid {
  background-color: #ffffff !important;

  border: 1px solid #fe5000 !important;

  transition: opacity 0.4s ease-in-out;
  margin: 1px;
}

.v-list {
  height: 500px; /* or any height you want */
  overflow-y: auto;
}
#row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
